import React, { useState, useEffect } from 'react';
import { FiDownload, FiSmartphone, FiX } from 'react-icons/fi';

const InstallPWA = () => {
  const [showInstall, setShowInstall] = useState(false);
  const [isIOS, setIsIOS] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);

  useEffect(() => {
    // Detectar si ya está instalada
    const standalone = window.matchMedia('(display-mode: standalone)').matches;
    setIsStandalone(standalone);

    // Detectar si es iOS
    const iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    setIsIOS(iOS);

    // Mostrar solo si NO está instalada
    if (!standalone) {
      setShowInstall(true);
    }
  }, []);

  const handleInstall = () => {
    if (isIOS) {
      // Instrucciones para iOS
      alert('Para instalar en iPhone:\n\n1. Toca el botón Compartir\n2. Desplázate y toca "Agregar a pantalla de inicio"');
    } else {
      // Intentar instalación en Android/Desktop
      alert('Para instalar en Android:\n\n1. Abre el menú (3 puntos)\n2. Toca "Instalar app" o "Agregar a pantalla de inicio"');
    }
  };

  if (isStandalone) return null; // No mostrar si ya está instalada

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <button
        onClick={handleInstall}
        className="bg-blue-600 text-white px-6 py-3 rounded-full shadow-lg hover:bg-blue-700 transition-all flex items-center gap-2 animate-pulse"
      >
        <FiDownload size={20} />
        <span>Instalar App</span>
        {isIOS && <FiSmartphone className="ml-1" size={16} />}
      </button>
    </div>
  );
};

export default InstallPWA;